import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedPageInformationComponent } from '~/organizer/shared/components/pages/information/information.component';
import { OrganizerSharedPageOverviewComponent } from '~/organizer/shared/components/pages/overview/overview.component';
import { OrganizerSharedPageStepsComponent } from '~/organizer/shared/components/pages/steps/steps.component';
import { OrganizerSharedClearActivityGuard } from '~/organizer/shared/guards/clear-activity/clear-activity.guard';
import { OrganizerSharedGetActivityByQueryIdGuard } from '~/organizer/shared/guards/get-activity-by-query-id/get-activity-by-query-id.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasActivityGuard } from '~/organizer/shared/guards/has-activity/has-activity.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerSharedOrganizationMandatoryFieldsGuard } from '~/organizer/shared/guards/organization-mandatory-fields/organization-mandatory-fields.guard';

import { OrganizerActivityCreationPageAddressComponent } from './components/pages/address/address.component';
import { OrganizerActivityCreationPageAudienceComponent } from './components/pages/audience/audience.component';
import { OrganizerActivityCreationPageSportBirthdayOfferComponent } from './components/pages/birthday-sport-offer/birthday-sport-offer.component';
import { OrganizerActivityCreationPageDescriptionComponent } from './components/pages/description/description.component';
import { OrganizerActivityCreationPageDurationComponent } from './components/pages/duration/duration.component';
import { OrganizerActivityCreationPageEquipmentComponent } from './components/pages/equipment/equipment.component';
import { OrganizerActivityCreationPageGroupSizeComponent } from './components/pages/group-size/group-size.component';
import { OrganizerActivityCreationPagePhotosComponent } from './components/pages/photos/photos.component';
import { OrganizerActivityCreationPagePlansComponent } from './components/pages/plans/plans.component';
import { OrganizerActivityCreationPagePreviewComponent } from './components/pages/preview/preview.component';
import { OrganizerActivityCreationPageSportComponent } from './components/pages/sport/sport.component';
import { OrganizerActivityCreationPageTitleComponent } from './components/pages/title/title.component';
import { OrganizerActivityCreationPageTypeComponent } from './components/pages/type/type.component';
import { OrganizerActivityCreationPageUploadsComponent } from './components/pages/uploads/uploads.component';
import { OrganizerActivityCreationPageUrlComponent } from './components/pages/url/url.component';

const routes: Routes = [
  {
    path: 'organizer.activity-creation.welcome',
    component: OrganizerSharedPageInformationComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.advice',
    component: OrganizerSharedPageInformationComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.steps',
    component: OrganizerSharedPageStepsComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.steps-1',
    component: OrganizerSharedPageOverviewComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.sport',
    component: OrganizerActivityCreationPageSportComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.type',
    component: OrganizerActivityCreationPageTypeComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.plans',
    component: OrganizerActivityCreationPagePlansComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.duration',
    component: OrganizerActivityCreationPageDurationComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.audience',
    component: OrganizerActivityCreationPageAudienceComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.address',
    component: OrganizerActivityCreationPageAddressComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.equipment-provided',
    component: OrganizerActivityCreationPageEquipmentComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.equipment-required',
    component: OrganizerActivityCreationPageEquipmentComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.birthday-sport-offer',
    component: OrganizerActivityCreationPageSportBirthdayOfferComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.description',
    component: OrganizerActivityCreationPageDescriptionComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.title',
    component: OrganizerActivityCreationPageTitleComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.photos',
    component: OrganizerActivityCreationPagePhotosComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.uploads',
    component: OrganizerActivityCreationPageUploadsComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.group-size',
    component: OrganizerActivityCreationPageGroupSizeComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.url',
    component: OrganizerActivityCreationPageUrlComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-creation.preview',
    component: OrganizerActivityCreationPagePreviewComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedOrganizationMandatoryFieldsGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedClearActivityGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerActivityCreationRoutingModule {}
